/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from 'react-bootstrap';
import { HTTP_STATUS_MESSAGES } from '../../../../src/const.js';

const status_msg = {
  nodata: 'No data available.'
};

const type_style = {
  info: { style: 'info', icon: 'error_outline' },
  nodata: { style: 'info', icon: 'error_outline' },
  error: { style: 'danger', icon: 'warning' },
  success: { style: 'success', icon: 'thumb_up' }
};

/**
 * @prop type : {info, nodata, error} "success", "danger", "info"
 * @prop data : object:Error, string:Message
 */
class Notification extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alertVisible: true
    };

    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
  }

  handleAlertDismiss() {
    this.setState({ alertVisible: false });
  }

  render() {
    const type = this.props.type;
    let msg,
      lookByType = type_style[this.props.type];

    if (type == 'error') {
      const error = this.props.data;
      msg = 'Something went wrong. Please try again or contact the Helpdesk.';
      if (typeof error == 'string') {
        msg = error;
      } else if (error.response && error.response.status && HTTP_STATUS_MESSAGES[error.response.status]) {
        msg = HTTP_STATUS_MESSAGES[error.response.status];
        if (error.response.status == '404') {
          /**
           * treat 404 as no data info because the majority of backend
           * endpoints return 404 when no data was found
           * E.g. 404 instead of 200 with empty body
           */
          lookByType = type_style['info'];
        }
      } else if (error.status) {
        /*content api fetch without response wrapper*/
        msg = HTTP_STATUS_MESSAGES[error.status];
      } else if (error.message) {
        msg = error.message;
      }
    } else {
      msg = status_msg[type];
      if (this.props.data) {
        msg = this.props.data;
      }
    }

    if (this.state.alertVisible) {
      return (
        <Alert
          id="tc-notification"
          className="tc-notification"
          bsStyle={lookByType.style}
          onDismiss={this.handleAlertDismiss}
        >
          <div className="tc-notification-col tc-notification-icon">
            <i id="tc-notification-icon" className="material-icons">
              {lookByType.icon}
            </i>
          </div>
          <div id="tc-notification-message" className="tc-notification-col tc-notification-message">
            {msg}
          </div>
        </Alert>
      );
    } else {
      return null;
    }
  }
}

Notification.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.any.isRequired
};

export default Notification;
